import gql from 'graphql-tag';

/** Shared channel settings fields for bulk module enable/disable tooling. */
const bulkModuleSettingsFragment = gql`
  fragment BulkModuleSettings on ChannelSettings {
    hasPerksEnabled
    hasBillingPaymentsEnabled
    hasWorkOrderServiceRequestsEnabled
    hasWorkOrderPreventiveMaintenanceEnabled
    hasWorkOrderEquipmentEnabled
    hasVisitorManagementEnabled
    hasHardwareManagementEnabled
    hasHardwarePinManagementEnabled
    hasReservableManagementEnabled
    hasWorkOrderCrossPropertyEnabled
    hasAccessControlEnabled
    hasSmartUserManagementEnabled
    multiLanguageEnabled
    hasSurveysEnabled
    hasMessagingAndMarketplaceEnabled
    hasInspectionsEnabled
  }
`;

/**
 * Paginated channel list for bulk module tooling.
 *
 * Uses the admin-only `bulkModuleChannels` resolver so bulk module enablement
 * gets a stable, name-ordered list without querybuilder role joins.
 */
export const bulkCriteriaChannelsQuery = gql`
  ${bulkModuleSettingsFragment}
  query BulkCriteriaChannels(
    $pagination: PaginationInput!
    $search: ChannelSearch!
  ) {
    bulkModuleChannels(pagination: $pagination, search: $search) {
      pageInfo {
        start
        total
        perPage
      }
      items {
        _id
        name
        slug
        type
        parent {
          _id
          name
        }
        settings {
          ...BulkModuleSettings
        }
      }
    }
  }
`;

export const bulkHierarchyChannelsQuery = gql`
  ${bulkModuleSettingsFragment}
  query BulkHierarchyChannels(
    $pagination: PaginationInput!
    $search: ChannelSearch!
  ) {
    bulkModuleChannels(pagination: $pagination, search: $search) {
      pageInfo {
        start
        total
        perPage
      }
      items {
        _id
        name
        slug
        type
        parent {
          _id
        }
        settings {
          ...BulkModuleSettings
        }
      }
    }
  }
`;

/**
 * Root-channel search for the bulk module parent picker (`parent: null` → no parent).
 *
 * Uses the same admin-only `bulkModuleChannels` resolver path as criteria and
 * hierarchy bulk queries.
 */
export const bulkParentChannelsQuery = gql`
  query BulkParentChannels(
    $pagination: PaginationInput!
    $search: ChannelSearch!
  ) {
    bulkModuleChannels(pagination: $pagination, search: $search) {
      pageInfo {
        start
        total
        perPage
      }
      items {
        _id
        name
        slug
        type
      }
    }
  }
`;
